import { loggingEndpoint } from './base.config';

export const logging = {
  fetchPaymentLogErrors: `${loggingEndpoint}/logging/payment-log-errors`,
};
